import { iots, option } from '@code-expert/prelude';
import { TaskId } from '/imports/domain';
import { QuestionId, QuizSnapshotId } from '/imports/modules/Quizzes/domain';
import { end, formatRoute, lit, query, type, url } from '/imports/modules/Routing';

const quizzes = lit('quizzes');
const manage = lit('manage');

const taskId = type('taskId', TaskId);
const questionId = type('questionId', QuestionId);

const snapshotQueryParams = query(
  iots.exact(
    iots.partial({
      snapshot: QuizSnapshotId,
    }),
  ),
);

export const editQuizRoute = url(quizzes, manage, taskId, snapshotQueryParams, end);

export const editQuizLink = ({
  taskId,
  snapshotId,
}: {
  taskId: TaskId;
  snapshotId: option.Option<QuizSnapshotId>;
}) => formatRoute(editQuizRoute)({ taskId, snapshot: option.toUndefined(snapshotId) });

export const editQuestionRoute = url(quizzes, manage, taskId, questionId, snapshotQueryParams, end);

export const editQuestionLink = ({
  taskId,
  questionId,
  snapshotId,
}: {
  taskId: TaskId;
  questionId: QuestionId;
  snapshotId: option.Option<QuizSnapshotId>;
}) =>
  formatRoute(editQuestionRoute)({ taskId, questionId, snapshot: option.toUndefined(snapshotId) });
